import styled from 'styled-components';

export default styled.img`
  width: ${props => props.theme.gridSize * 12}px;
  height: ${props => props.theme.gridSize * 12}px;
  border-radius: ${props => !props.square && '100%'};
`;
